import { styled } from "@mui/material";
import React from "react";

export const Offset = styled("div")(({ theme }) => theme.mixins.toolbar);
